var map = {
	"./disgust1.jpg": "ca3c",
	"./disgust2.jpg": "6745",
	"./disgust3.jpg": "f8eb",
	"./disgust4.jpg": "fd6e",
	"./fear1.jpg": "cd5e",
	"./fear2.jpg": "10f9",
	"./fear3.jpg": "a309",
	"./fear4.jpg": "6e9f",
	"./interest1.jpg": "615f",
	"./interest2.jpg": "00e2a",
	"./interest3.jpg": "ed41",
	"./interest4.jpg": "4633",
	"./joy1.jpg": "244b",
	"./joy2.jpg": "5beb",
	"./joy3.jpg": "3ee2",
	"./joy4.jpg": "c6b62",
	"./neutral.jpg": "13ab",
	"./sadness1.jpg": "08e7",
	"./sadness2.jpg": "303f",
	"./sadness3.jpg": "25f2",
	"./sadness4.jpg": "b0ba",
	"./surprize1.jpg": "b6dc",
	"./surprize2.jpg": "7ead",
	"./surprize3.jpg": "71e1",
	"./surprize4.jpg": "73db",
	"./trust1.jpg": "fedd",
	"./trust2.jpg": "4a47",
	"./trust3.jpg": "82f9",
	"./trust4.jpg": "1673"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0753";